const TestPage = () => {
  const NODE_ENV = process.env.NODE_ENV
  const featureFlags = {
    NODE_ENV,
    REACT_APP_ENABLE_STATE_REPORTS: process.env.REACT_APP_ENABLE_STATE_REPORTS
  }
  const reactAppEnv = Object.keys(process.env)
  .filter((key) => key.startsWith('REACT_APP_'))
  .reduce((env, key) => {
    env[key] = process.env[key];
    return env;
  }, {} as Record<string, string | undefined>)

  const handleTest = () => {
    console.log({featureFlags, reactAppEnv})
  }
  return (
    <div>
      <button onClick={handleTest}>Test {NODE_ENV}</button>
      <pre>{JSON.stringify(reactAppEnv)}</pre>
    </div>
  )
}

export default TestPage
